import { defaultColorSchemes } from "./schemes/index.js";
export function createColorSchemes(schemes) {
    if (!schemes)
        return createColorSchemes(defaultColorSchemes);
    return { schemes };
}
export default createColorSchemes;
//# sourceMappingURL=create-color-schemes.js.map